module.exports = __webpack_public_path__ + "img/bg10.8d3c8149.gif";